module.exports = {
    title:"Book Talk",
    description: "Find best books people are reading",
    heading: "Books this Week"
}